var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32_9148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33334 2.66714H4.53334C3.41324 2.66714 2.85319 2.66714 2.42536 2.88513C2.04904 3.07688 1.74308 3.38284 1.55133 3.75916C1.33334 4.18699 1.33334 4.74704 1.33334 5.86714V11.4671C1.33334 12.5872 1.33334 13.1473 1.55133 13.5751C1.74308 13.9514 2.04904 14.2574 2.42536 14.4492C2.85319 14.6671 3.41324 14.6671 4.53334 14.6671H10.1333C11.2534 14.6671 11.8135 14.6671 12.2413 14.4492C12.6176 14.2574 12.9236 13.9514 13.1154 13.5751C13.3333 13.1473 13.3333 12.5872 13.3333 11.4671V8.66714M5.33333 10.6671H6.44969C6.77581 10.6671 6.93887 10.6671 7.09232 10.6303C7.22837 10.5976 7.35843 10.5438 7.47772 10.4707C7.61228 10.3882 7.72758 10.2729 7.95818 10.0423L14.3333 3.66714C14.8856 3.11486 14.8856 2.21943 14.3333 1.66714C13.7811 1.11486 12.8856 1.11486 12.3333 1.66714L5.95817 8.04231C5.72756 8.27291 5.61226 8.38821 5.52981 8.52276C5.4567 8.64206 5.40283 8.77212 5.37017 8.90817C5.33333 9.06162 5.33333 9.22468 5.33333 9.5508V10.6671Z",
    stroke: "#999999",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_9148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.a57bcb05131fae53db83dcbe4f5beac8.svg";
export { ForwardRef as ReactComponent };